module.exports = __webpack_public_path__ + "7b941222d1b91e2367620852d2ab7162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/circle-white.png
// module id = 35
// module chunks = 0